// -----------------------------------------------------------------------------
// AlertsPage — Vue des alertes (stock bas + DLC proches)
// StockPro / VisualisPro
// -----------------------------------------------------------------------------

import { T } from "../../i18n/translations";
import { getColors } from "../../styles/theme";
import { daysUntil } from "../../utils/date";
import { Ic, ICONS } from "../Icons";

export default function AlertsPage({
  lang,
  dark,
  alerts,
  dlcAlerts,
  totalAlerts,
  onExportList,
}) {
  const t = T[lang];
  const { textPrimary, textSecondary } = getColors(dark);

  return (
    <div className="slide-in">
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginBottom:20 }}>
        <div>
          <h1 style={{ fontSize:22, fontWeight:800, color:textPrimary }}>{t.alerts}</h1>
          <p style={{ color:textSecondary, fontSize:12, marginTop:2 }}>{totalAlerts} en alerte</p>
        </div>
        {totalAlerts > 0 && (
          <button onClick={onExportList} style={{ padding:"9px 14px", borderRadius:9, background:"rgba(16,185,129,.1)", color:"#10b981", border:"1px solid rgba(16,185,129,.2)", fontSize:13, fontWeight:600, cursor:"pointer", display:"flex", alignItems:"center", gap:6 }}>
            <Ic d={ICONS.dl} size={14} color="#10b981" /> {t.exportList}
          </button>
        )}
      </div>
      {!totalAlerts ? (
        <div className="card" style={{ padding:"50px 20px", textAlign:"center" }}>
          <div style={{ width:50, height:50, background:"rgba(16,185,129,.1)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 12px" }}>
            <Ic d={ICONS.check} size={24} color="#10b981" />
          </div>
          <div style={{ fontWeight:700, color:"#10b981", fontSize:14 }}>{t.allGood}</div>
        </div>
      ) : (
        <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
          {[...new Map([...alerts, ...dlcAlerts].map(p => [p.id, p])).values()].map(p => {
            const isLow = p.qty <= p.alert;
            // eslint-disable-next-line no-unused-vars
            const dlcD = daysUntil(p.dlc);
            return (
              <div key={p.id} className="card" style={{ padding:"16px 18px", borderColor:isLow?"rgba(239,68,68,.2)":"rgba(245,158,11,.2)" }}>
                <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between" }}>
                  <div style={{ display:"flex", alignItems:"center", gap:11 }}>
                    <div style={{ width:40, height:40, background:isLow?"rgba(239,68,68,.1)":"rgba(245,158,11,.1)", borderRadius:10, display:"flex", alignItems:"center", justifyContent:"center" }}>
                      <Ic d={ICONS.warn} size={18} color={isLow?"#ef4444":"#f59e0b"} />
                    </div>
                    <div>
                      <div style={{ fontWeight:700, color:textPrimary, fontSize:14 }}>{p.name}</div>
                      <div style={{ color:textSecondary, fontSize:11, marginTop:1 }}>{p.cat} · {p.zone}</div>
                    </div>
                  </div>
                  <div style={{ textAlign:"right" }}>
                    <div style={{ fontSize:24, fontWeight:800, color:isLow?"#f87171":"#fbbf24", fontFamily:"'JetBrains Mono',monospace" }}>{p.qty}</div>
                    <div style={{ fontSize:10, color:textSecondary }}>{p.unit}</div>
                  </div>
                </div>
                {isLow && (
                  <>
                    <div style={{ marginTop:10, height:4, background:dark?"rgba(255,255,255,.05)":"rgba(0,0,0,.06)", borderRadius:2 }}>
                      <div style={{ height:"100%", width:`${Math.min(100,(p.qty/p.alert)*100)}%`, background:"linear-gradient(90deg,#ef4444,#f97316)", borderRadius:2 }} />
                    </div>
                    <div style={{ marginTop:7, fontSize:11, color:textSecondary }}>
                      {t.orderAt} <strong style={{ color:"#f87171" }}>{Math.max(0, p.alert - p.qty + 5)} {p.unit}</strong> {t.toSafeZone}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
